export const moveToFirstStep = (currentStep, setCurrentStep, setPreveStep) => {
  if (currentStep === 0) return;
  setPreveStep(0);
  setCurrentStep(0);
};
